<!-- 奖励详情 -->
<template>
  <div class="main">
    <div class="content">
        <van-image class="img"
            src="/image/detail/logo.png"
        />
        <div class="rewordImg">
            <svg
                class="icon "
                aria-hidden="true"
            >
                <use xlink:href="#icon41jianglixiangqing"></use>
            </svg>
        </div>
        <!-- 奖励日期 -->
        <div class="item">
            <div class="left">奖励日期：</div>
            <div class="right">{{ rewardInfo.accountingDate }}</div>
        </div>
        <!-- 奖励金额 -->
        <div class="item">
            <div class="left">奖励金额：</div>
            <div class="right">¥ {{ formatNum(rewardInfo.rewardAmount) }}</div>
        </div>
        <div
            v-for="item in rewardInfo.list"
            :key="item.num"
        >
            <div class="level">当前核算等级：LV{{ item.partnerHistoryLevel }}</div>
            <div class="item">
                <div class="left">入账会员奖励：</div>
                <div class="right">¥ {{ formatNum(item.entryAmountRecorded) }}</div>
            </div>
            <div class="item">
                <div class="left">入账流水奖励：</div>
                <div class="right">¥ {{ formatNum(item.flowAmountRecorded) }}</div>
            </div>
        </div>
    </div>
    <div class="foot-title-box">
      <div class="foot-title">
        {{ $t('app.title.footTitle') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Image as vanImage } from 'vant'
import { apiGet } from '@/services'
import { formatNum } from '@/utils'
export default {
  name: 'reword',
  components: { vanImage },
  data() {
    return {
        formatNum,
        rewardInfo: {}
    }
  },
  created() {
      this.getReward()
  },
  methods: {
      // 获取奖励详情数据
      getReward() {
          const data = {
              accountingDate: this.$route.params.accountingDate
          }
          apiGet('partner/open/reward/record/detail', data).then(res => {
              if (res.code === '0000') {
                  this.rewardInfo = res.data
              } else {
                this.$handleErr(res.msg)
              }
          })
      }
  }
}
</script>

<style lang="less" scoped>
.main{
    width:100%;
    min-height:100%;
    background: #121212;
    padding: 0 16px;
    padding-top: 24px;
    box-sizing: border-box;
    .content{
        position: relative;
        width:343px;
        background: #282830;
        border-radius:4px;
        margin-bottom: 20px;
        padding-bottom: 75px;
        .img{
            width: 108px;
            height: 36px;
            margin: 19px 0;
        }
        .rewordImg{
            color: rgba(255,255,255,0.86);
            margin: 0 auto;
            margin-bottom: 34px;
            width: 168px;
            height: 54px;
            text-align: center;
            svg{
                width: 100%;
                height: 100%;
            }
        }
        .level{
            height:21px;
            font-size:15px;
            font-weight:500;
            color: rgba(255,255,255,0.86);
            line-height:21px;
            padding: 0 44px 20px;
        }
        .item{
            display: flex;
            justify-content: space-between;
            padding: 0 44px 20px;
            &.col{
                display: flex;
                flex-direction: column;
            }
            .left{
                height:21px;
                font-size:14px;
                font-weight:500;
                color: rgba(255,255,255,0.60);
                line-height:21px;
            }
            .right{
                height:21px;
                font-size:15px;
                font-weight:bold;
                color: rgba(255,255,255,0.86);
                line-height:21px;
            }
        }
        .recordImg{
            position:absolute;
            width: 126px;
            height: 100px;
            right: 0;
            bottom: -17px;
        }
    }
    .foot-title-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .foot-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:13px;
      color: rgba(255, 255, 255, 0.6);
      &::after, &::before {
        content: '';
        display: block;
        width:32px;
        height:1px;
        background:linear-gradient(270deg,rgba(238,238,238,0) 0%,rgba(216,216,216,1) 100%);
        opacity:0.3;
        margin-left: 8px;
      }
      &::before {
        margin: 0;
        margin-right: 8px;
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
